var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',_vm._l((_vm.posts.slice().reverse()),function(post,index){return _c('b-col',{key:index,attrs:{"lg":"4","md":"12"}},[_c('div',{staticClass:"myCard h-100"},[_c('div',{staticClass:"myCardInner h-100"},[_c('PostPreview',{attrs:{"post":post}})],1)])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a414c9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = null
// module chunks = 